<template>
  <nav class="navbar navbar-expand-lg fixed-top">
    <div class="container navbar-custom-container">
      <router-link class="navbar-brand d-flex align-items-center" to="/">
        <img src="@/assets/logo.png" alt="Logo" height="42" class="me-2" />
        <div class="brand-text-group">
          <span class="brand-title">KEMENHUB</span>
          <span class="brand-subtitle">ETLE HUB</span>
        </div>
      </router-link>

      <button 
        class="navbar-toggler custom-hub-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarNav"
        aria-controls="navbarNav" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span class="toggler-icon-bar"></span>
        <span class="toggler-icon-bar"></span>
        <span class="toggler-icon-bar"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul class="navbar-nav align-items-lg-center">
          <li class="nav-item">
            <router-link class="nav-link" exact to="/" active-class="active">
              <i class="bi bi-house-door me-1"></i> Beranda
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/cek-data" active-class="active">
              <i class="bi bi-search me-1"></i> Cek Data
            </router-link>
          </li> -->
          <li class="nav-item">
            <router-link class="nav-link" to="/konfirmasi" active-class="active">
              <i class="bi bi-check-circle me-1"></i> Konfirmasi
            </router-link>
          </li>
          <li class="nav-item" v-if="showCekPelanggaran">
            <router-link class="nav-link links-highlight" to="/cek-pelanggaran" active-class="active">
              <i class="bi bi-exclamation-triangle me-1"></i> Cek Pelanggaran
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link btn-faq-style" to="/Faq" active-class="active">
              FAQ
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavbarComponent",
  computed: {
    showCekPelanggaran() {
      return sessionStorage.getItem("showCekPelanggaran") === "true";
    },
  },
};
</script>

<style scoped>
.navbar {
  background-color: #2e3686; 
  padding: 14px 0;
  transition: all 0.3s ease;
  border-bottom: 3px solid #f1f5f9; 
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.navbar-brand {
  text-decoration: none;
}

.brand-text-group {
  display: flex;
  flex-direction: column;
}

.brand-title {
  color: #ffffff;
  font-weight: 800;
  font-size: 1.4rem;
  letter-spacing: 1.5px;
  line-height: 1.1;
}

.brand-subtitle {
  color: #e2e8f0; 
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
}

.nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
  margin: 0 6px;
  font-size: 18px;
  font-weight: 500;
  padding: 10px 20px !important;
  border-radius: 30px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.nav-link i {
  font-size: 20px;
  opacity: 0.9;
}

.nav-link:hover {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.12); 
}

.nav-link.active {
  color: #2e3686 !important; 
  background-color: #ffffff; 
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.links-highlight {
  border: 1px dashed rgba(255, 255, 255, 0.4);
}

.btn-faq-style {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-hub-toggler {
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
  padding: 6px;
}

.custom-hub-toggler:focus {
  box-shadow: none;
}

.toggler-icon-bar {
  display: block;
  width: 26px;
  height: 2.5px;
  background-color: #ffffff;
  border-radius: 2px;
  transition: all 0.2s;
}

.navbar-toggler {
  display: none;
}

@media (max-width: 991.98px) {
  .navbar-toggler {
    display: flex;
  }

  .navbar {
    padding: 12px 0;
  }

  .navbar-nav {
    background-color: #222969; 
    padding: 14px;
    border-radius: 14px;
    margin-top: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .nav-link {
    margin: 6px 0;
    padding: 12px 16px !important;
    border-radius: 8px;
    font-size: 17px;
  }

  .nav-link.active {
    background-color: rgba(255, 255, 255, 0.15);
    color: #ffffff !important;
    border-left: 5px solid #ffffff;
    border-radius: 4px;
    box-shadow: none;
  }
}
</style>